import React from 'react';
import { ratingColor } from '../lib/driveBucket';

export default function RatingColorBar({ value, max = 5, height = 6, showValue = true }) {
  if (value == null || value === '' || Number.isNaN(Number(value))) {
    return <span className="text-gray-400">—</span>;
  }
  const v = Math.max(0, Math.min(max, Number(value)));
  const pct = max > 0 ? (v / max) * 100 : 0;
  const hex = ratingColor(pct);
  return (
    <div className="inline-flex items-center gap-2 w-full min-w-[60px]">
      <div
        className="flex-1 rounded-full bg-gray-100 dark:bg-gray-800 overflow-hidden"
        style={{ height }}
      >
        <div
          className="h-full rounded-full"
          style={{ width: `${pct}%`, backgroundColor: hex, transition: 'width 200ms ease' }}
        />
      </div>
      {showValue && (
        <span className="text-xs text-gray-700 dark:text-gray-300 tabular-nums">{v.toFixed(1)}</span>
      )}
    </div>
  );
}
